<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("filmwisecollectionreport") }}
      </div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div
              :class="[
                'mb-1',
                Cinemas ? 'col-lg-12 col-xl-12' : 'col-lg-6 col-xl-3',
              ]"
            >
              <div class="dropdown-curve-container">
                <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
                  $tc("")
                }}</label>
                <multiselect
                  v-model="selectedCinema"
                  :options="Cinemas"
                  :multiple="true"
                  :group-select="true"
                  placeholder="Select Cinema"
                  track-by="cine_id"
                  label="cine_name"
                ></multiselect>
              </div>
            </div>
          </div>

          <!-- START DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button class="btn-clearDate">
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="FilmWise.start_date"
                    type="date"
                    class="theme-custom-date-time  w-100"
                    typeable
                    id="filmwise_startdate"
                    name="filmwise_startdate"
                    v-validate="'required'"
                  ></Datepicker>
                </div>
                <label :class="FilmWise.start_date ? 'active' : ''"
                  >{{ $t("transaction") }} {{ $t("startdate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- END DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button class="btn-clearDate">
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="FilmWise.end_date"
                    type="date"
                    class="theme-custom-date-time  w-100"
                    typeable
                    id="filmwise_enddate"
                    name="filmwise_enddate"
                    v-validate="'required'"
                  ></Datepicker>
                </div>
                <label :class="FilmWise.end_date ? 'active' : ''"
                  >{{ $t("transaction") }} {{ $t("enddate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- SELECT DISTRIBUTOR -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="FilmWise.selectedDistributor ? 'shift-up' : ''"
                >Select Distributor</label
              >
              <multiselect
                v-model="FilmWise.selectedDistributor"
                :options="Distributor"
                label="d_company_name"
                track-by="d_id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Distributor"
                @input="getselectedDistibutor()"
              ></multiselect>
            </div>
          </div>

          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-4 align-self-center ml-3 mb-3">
            <div class="dropdown-curve-container">
              <label :class="FilmWise.selectedMovie ? 'shift-up' : ''"
                >Select Movies</label
              >
              <multiselect
                v-model="FilmWise.selectedMovie"
                :options="MovieList"
                label="movie"
                track-by="md_id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Movie"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              @click="getFilmWiseCollectionReport()"
              class="btn-blue-lg w-100"
            >
              {{ $tc("Fetch Report") }}
            </button>
          </div>

          <div
            v-if="finalResArr.length > 0"
            class="col-lg-6 col-xl-4 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <a href="#" @click="generateReport()" title="Download as PDF">
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                class="mx-1"
                height="25"
                width="25"
              />
            </a>
            <a href="#" @click="excelDownload()" title="Download as Excel">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :paginate-elements-by-height="1400"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a2"
          pdf-orientation="landscape"
          pdf-content-width="100%"
          @beforeDownload="beforeDownload($event)"
          ref="html2Pdf"
        >
          <table
            class="swc-report-table filmwise-report-table"
            slot="pdf-content"
            border="1"
          >
            <thead>
              <tr>
                <th class="bg-lightgrey text-left">{{ $tc("screen", 1) }}</th>
                <th class="bg-lightgrey">{{ $t("show") }} {{ $t("time") }}</th>
                <th class="bg-lightgrey">{{ $t("show") }} {{ $t("date") }}</th>
                <th class="bg-lightgrey">{{ $tc("shift", 1) }}</th>
                <th class="bg-lightgrey">{{ $t("class") }}</th>
                <th class="bg-lightgrey">
                  {{ $tc("ticket", 1) }} {{ $tc("type", 1) }}
                </th>
                <th class="bg-lightgrey">
                  {{ $tc("Rate", 1) }}
                </th>
                <th class="bg-lightgrey">
                  {{ $tc("ticket") }}
                </th>
                <th class="bg-lightgrey">
                  {{ $tc("gross") }} {{ $tc("amount") }}
                </th>
                <th class="bg-lightgrey">
                  {{ $tc("Discount") }}
                </th>
                <th class="bg-lightgrey">
                  {{ $tc("Tax") }}
                </th>
                <th class="bg-lightgrey text-right">
                  {{ $t("Total") }} {{ $t("(-disc)") }}
                </th>
              </tr>
            </thead>
            <div
              v-for="(movieArr, movieArrIndex) in finalResArr"
              :key="movieArrIndex"
            >
              <tr v-if="movieArrIndex > 0">
                <td v-if="finalResArr !== 0" :colspan="12">
                  <div class="p-3"></div>
                </td>
              </tr>
              <tbody>
                <tr>
                  <td :colspan="6" class="p-0">
                    <div
                      class="color-pink d-flex w-100 justify-content-start py-2 border-top border-dark"
                      style="padding-left: 2px; padding-right: 2px"
                    >
                      <div class="mr-3">
                        <strong>{{ movieArr.movie_name }} </strong>
                      </div>
                    </div>
                  </td>
                  <td class="color-pink">Total</td>
                  <td
                    class="text-right color-pink"
                    v-for="(totalObj_new, t_index) in Object.keys(totalObj)"
                    :key="t_index"
                  >
                    {{
                      notCurrFormat.indexOf(totalObj_new) >= 0
                        ? movieArr[totalObj_new]
                        : currFormat(movieArr[totalObj_new])
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody
                v-for="(cinemaArr, cinemaIndex) in movieArr.cinema_array"
                :key="cinemaIndex"
              >
                <tr>
                  <td v-if="finalResArr !== 0" :colspan="7" class="p-0">
                    <div
                      class="color-blue d-flex w-100 justify-content-start py-2 border-top border-dark"
                    >
                      <strong>{{ cinemaArr.cinema_name }}</strong>
                    </div>
                  </td>
                  <td
                    class="text-right color-blue"
                    v-for="(totalObj_new, t_index) in Object.keys(totalObj)"
                    :key="t_index"
                  >
                    {{
                      notCurrFormat.indexOf(totalObj_new) >= 0
                        ? cinemaArr[totalObj_new]
                        : currFormat(cinemaArr[totalObj_new])
                    }}
                  </td>
                </tr>

                <tr
                  v-for="(screenArr, screenIndex) in cinemaArr.screen_array"
                  :key="screenIndex"
                >
                  <td class="text-right">{{ screenArr.screen_name }}</td>
                  <td>
                    {{
                      moment(screenArr.t_show_time, "HH:mm:ss").format("HH:mm")
                    }}
                  </td>
                  <td class="text-right">{{ screenArr.show_date }}</td>
                  <td class="text-left">{{ screenArr.shift_name }}</td>
                  <td class="text-left">{{ screenArr.seat_type_name }}</td>
                  <td class="text-left">{{ screenArr.ticket_type_name }}</td>
                  <td class="text-left">{{ currFormat(screenArr.rate) }}</td>
                  <td
                    class="text-right"
                    v-for="(totalObj_new, t_index) in Object.keys(totalObj)"
                    :key="t_index"
                  >
                    {{
                      notCurrFormat.indexOf(totalObj_new) >= 0
                        ? screenArr[totalObj_new]
                        : currFormat(screenArr[totalObj_new])
                    }}
                  </td>
                  <!-- <td class="text-right">{{ screenArr.gross_amount }}</td>
                <td class="text-right">{{ screenArr.offer_price }}</td>
                <td class="text-right">{{ screenArr.vat }}</td>
                <td class="text-right">{{ screenArr.t_net_amount }}</td> -->

                  <!-- <td>H-85.00</td>
              <td>H-85.00</td>-->
                </tr>

                <tr v-if="movieArr.cinema_array.length - 1 != cinemaIndex">
                  <td :colspan="12">
                    <div class="p-1"></div>
                  </td>
                </tr>
              </tbody>
            </div>
            <tr v-if="this.finalResArr.length == 0">
              <td colspan="14">
                <NoRecords />
              </td>
            </tr>
          </table>
        </vue-html2pdf>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import { BASEURL } from "@/config/index";
  import ReportsService from "@/services/ReportsService-v2";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import { createQueryString } from "../../../services/ApiHelper";
  import xlsx from "json-as-xlsx";
  import axios from "axios";
  import VueHtml2pdf from "vue-html2pdf";

  let Start_Date = moment(
    `${moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD")} 24:00:00`
  ).format();
  let End_date = moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).format();

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        selectedCinema: [],
        Cinemas: [],
        Distributor: [],
        MovieList: [],
        isRoleID: true,
        pdfFileName: "TestPdfFile",
        htmlToPdfOptions: {
          filename: this.pdfFileName,
          margin: 3,
          image: {
            type: "jpeg",
            quality: 0.98,
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            format: "a2",
            orientation: "landscape",
          },
        },

        CinemasCopy: [],
        searchCinema: "",
        selectedCinemaId: undefined,
        FilmWise: {
          start_date: Start_Date,
          end_date: End_date,
          selectedDistributor: "",
          selectedMovie: "",
          filmWiseCollectionResult: [],
          filmWiseTotalCharges: "",
          finalArr: [],
        },
        Movies_array: [
          {
            movies_name: "King",
            cinema_array: [
              {
                cinema_name: "Cinema 1",
                total_ticket_count: "",
                total_rate: "",
                total_vat: "",
                total_gross_sales: "",
                total_tax: "",
                total_net: "",
                screen_array: [
                  {
                    screen_name: "Screen 1",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                  {
                    screen_name: "Screen 2",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                ],
              },
              {
                cinema_name: "Cinema 2",
                total_ticket: "",
                total_rate: "",
                total_vat: "",
                total_gross_sales: "",
                total_tax: "",
                total_net: "",
                screen_array: [
                  {
                    screen_name: "Screen 2",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    rate: "123",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                  {
                    screen_name: "Screen 3",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    rate: "123",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                ],
              },
            ],
          },
          {
            movies_name: "Wolf",
            cinema_array: [
              {
                cinema_name: "Cinema 1",
                total_ticket: "",
                total_rate: "",
                total_vat: "",
                total_gross_sales: "",
                total_tax: "",
                total_net: "",
                screen_array: [
                  {
                    screen_name: "Screen 1",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    rate: "123",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                  {
                    screen_name: "Screen 2",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    rate: "123",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                ],
              },
              {
                cinema_name: "Cinema 2",
                total_ticket: "",
                total_rate: "",
                total_vat: "",
                total_gross_sales: "",
                total_tax: "",
                total_net: "1235",
                screen_array: [
                  {
                    screen_name: "Screen 2",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    rate: "123",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                  {
                    screen_name: "Screen 3",
                    t_show_time: "19:55",
                    show_date: "06-05-2022",
                    shift_name: "Day",
                    seat_type_name: "GOLD",
                    ticket_type_name: "Gold",
                    rate: "123",
                    total_ticket: 2,
                    gross_amount: 40,
                    vat: 0.8,
                    t_net_amount: "40",
                  },
                ],
              },
            ],
          },
        ],
        finalResArr: [],
        selectedGroupByArray: [
          {
            groupByKeyName: "md_id",
            groupByArrayName: "Movie_version_array",
          },
          {
            groupByKeyName: "cinema_id",
            groupByArrayName: "cinema_array",
          },
          {
            groupByKeyName: "screen_id",
            groupByArrayName: "screen_array",
          },
        ],
        totalObj: {
          Sold: 0,
          gross_amount: 0,
          offer_price: 0,
          total_taxes: 0,
          final_gross_amount: 0,
        },
        notCurrFormat: ["Sold"],
        // tdSpan:14
      };
    },
    computed: {},
    beforeMount() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      this.getCinemaList(cinemaId);
      this.fetchDistributorsList();
      this.getMoviesList();
    },
    watch: {},
    mounted() {
      // tdspan = this.$refs.swcTheadRef.children.length;
    },
    methods: {
      moment,
      async beforeDownload({ html2pdf, options, pdfContent }) {
        const date = new Date();
        this.pdfFileName = "Reports" + date.getTime();
        this.htmlToPdfOptions.filename = this.pdfFileName;
        await html2pdf()
          .set(this.htmlToPdfOptions)
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(18);
              pdf.setTextColor(150);
              pdf.text(
                "Page " + i + " of " + totalPages,
                pdf.internal.pageSize.getWidth() * 0.88,
                pdf.internal.pageSize.getHeight() - 0.3
              );
            }
          })
          .save();
      },

      generateReport() {
        this.$refs.html2Pdf &&
          this.$refs.html2Pdf.generatePdf &&
          this.$refs.html2Pdf.generatePdf();
      },
      excelDownload() {
        // let payload = {
        //   fromDate: moment(this.FilmWise.start_date).format("YYYY-MM-DD"),
        //   toDate: moment(this.FilmWise.end_date).format("YYYY-MM-DD"),
        //   // cinema_id: this.selectedCinema.map(z => z.cine_id),
        //   cinema_id: 1,
        //   cinema_name: "DEV - Stüssihof",
        //   d_id: this.FilmWise.selectedDistributor.d_id,
        //   d_company_name: null,
        //   movie_id: this.FilmWise.selectedMovie.md_id,
        //   movie_title: this.FilmWise.selectedMovie.movie,
        //   country_id: null,
        //   multiple_cinema_id: this.selectedCinema.map(z => z.cine_id)
        // };
        let temp_arr = [];
        let dataArr = this.FilmWise.filmWiseCollectionResult;
        // dataArr.map(arr1 => {
        //   arr1.map(arr2 => {
        //     arr2.Data.map(arr3 => {
        //       temp_arr.push(arr3);
        //     });
        //   });
        // });
        // temp_arr.map(z=>{
        this.finalResArr.map((arr1) => {
          arr1.cinema_array.map((arr2) => {
            arr2.screen_array.map((arr3) => {
              temp_arr.push(arr3);
            });
          });
        });

        let objGrandTotal = { ...temp_arr[0], ...this.totalObj };
        temp_arr.map((z) => {
          Object.keys(z).map((_key) => {
            if (this.totalObj.hasOwnProperty(_key) && z[_key]) {
              objGrandTotal[_key] = +parseFloat(
                objGrandTotal[_key] + z[_key]
              ).toFixed(2);
            } else if (_key == "rate") {
              objGrandTotal[_key] = "Grand Total";
            } else {
              objGrandTotal[_key] = "";
            }
          });
        });

        console.log(objGrandTotal, "objGrandTotal");

        temp_arr.push(objGrandTotal);

        let data = [
          {
            sheet: "FilmWiseCollection Report",
            columns: [
              {
                value: "movie_name",
                label: "Movie Name",
              },
              {
                value: "cinema_name",
                label: "Cinema Name",
              },
              {
                value: "screen_name",
                label: "Screen Name",
              },
              {
                value: "t_show_time",
                label: "Show Time",
              },
              {
                value: "show_date",
                label: "Show Date",
              },
              {
                value: "shift_name",
                label: "Shift",
              },
              {
                value: "seat_type_name",
                label: "Class",
              },
              {
                value: "ticket_type_name",
                label: "Ticket Type",
              },
              {
                value: "rate",
                label: "Rate",
              },
              {
                value: "gross_amount",
                label: "Gross Sales Price",
              },
              {
                value: "offer_price",
                label: "Discount",
              },
              {
                value: "total_taxes",
                label: "Tax",
              },
              {
                value: "final_gross_amount",
                label: "Total",
              },
              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: temp_arr,
          },
        ];
        let settings = {
          fileName: `FilmWiseCollectionReport${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      getCinemaList(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              console.log(this.Cinemas);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._catchError);
      },
      fetchDistributorsList() {
        MasterService.GetAllDistributors({ is_Active: "Y" })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Distributor = data.Records;
              console.log(this.Distributor);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._catchError);
      },
      getselectedDistibutor() {
        console.log("this.getDist", this.FilmWise.selectedDistributor);
      },
      getDateValues() {
        console.log(
          "this.getDist",
          moment(this.FilmWise.end_date).format("YYYY-MM-DD")
        );
      },
      getMoviesList() {
        MovieService.GetActiveMoviesWithFormat({
          cinema_id: this.selectedCinema[0],
          movieversions: "Y",
        }).then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.MovieList = data.Records;
          }
        });
      },
      getFilmWiseCollectionReport() {
        let payload = {
          fromDate: moment(this.FilmWise.start_date).format("YYYY-MM-DD"),
          toDate: moment(this.FilmWise.end_date).format("YYYY-MM-DD"),
          // cinema_id: this.selectedCinema.map(z => z.cine_id),
          cinema_id: 1,
          cinema_name: "DEV - Stüssihof",
          d_id: this.FilmWise.selectedDistributor.d_id,
          d_company_name: this.FilmWise.selectedDistributor.d_company_name,
          movie_id: this.FilmWise.selectedMovie.md_id,
          movie_title: this.FilmWise.selectedMovie.movie,
          country_id: null,
          multiple_cinema_id: this.selectedCinema.map((z) => z.cine_id),
        };
        // let payload = {
        //   fromDate: "2022-05-06",
        //   toDate: "2022-05-06",
        //   cinema_id: 1,
        //   cinema_name: "DEV - Stüssihof",
        //   d_id: null,
        //   d_company_name: null,
        //   movie_id: null,
        //   movie_title: null,
        //   country_id: 212,
        //   multiple_cinema_id: [1, 2]
        // };
        ReportsService.GetFilmWiseCollectionReport(payload)
          .then((response) => {
            let loader = this.$loading.show();
            const { data } = response;
            if (this.selectedCinema.length <= 0) {
              this.$toasted.show("Select Cinema");
            }
            if (data.status && data.data.length > 0) {
              this.FilmWise.filmWiseTotalCharges = data.FinalTotalCharges;
              this.FilmWise.filmWiseCollectionResult = data.data;
              console.log(
                "this.filmdata",
                this.FilmWise.filmWiseCollectionResult[0][0].Data[0]
              );
              this.showFinalData();
              if (this.FilmWise.filmWiseCollectionResult.length >= 0) {
                setTimeout(() => loader.hide(), 100);
              }
            } else {
              this.finalResArr = [];
              setTimeout(() => loader.hide(), 100);
              this.$toasted.show(data.message);
            }
          })
          .catch(this._catchError);
      },
      // saveDataArr() {
      //   if (this.FilmWise.filmWiseCollectionResult.length > 0) {
      //     let temp_arr = this.FilmWise.filmWiseCollectionResult;
      //     let cine_id;
      //     let test = [];
      //     if (this.selectedCinema.length > 0) {
      //       this.selectedCinema.map((z, z_idnex) => {
      //         // this.FilmWise.finalArr[z.cine_id] = "";
      //         temp_arr.map(y => {
      //           y.map(x => {
      //             cine_id = x.Data.map(filmArr => {
      //               if (filmArr.cinema_id == z.cine_id) {
      //                 test.push(filmArr);
      //               }
      //               return test;
      //             });
      //           });
      //           this.FilmWise.finalArr.push(cine_id);
      //         });
      //         console.log(cine_id);
      //       });
      //     }
      //   }
      //   console.log("data from final arr", this.FilmWise.finalArr);
      // }

      getRecordChildren(x, data2) {
        let data = _.groupBy(data2.dummy_data, x.groupByKeyName);
        data2[x.groupByArrayName] = [];
        Object.keys(data).map((z) => {
          let obj = {};
          obj[x.groupByKeyName] = z;
          obj["dummy_data"] = [];
          data[z].map((k) => {
            obj["dummy_data"].push(k);
          });

          let total_objNew = { ...this.totalObj };
          Object.keys(this.totalObj).map((_t) => {
            obj["dummy_data"].map((d_val) => {
              if (d_val[_t] && d_val.hasOwnProperty(_t)) {
                total_objNew[_t] = total_objNew[_t] + parseFloat(d_val[_t]);
              }
            });
          });

          // this.finalResArr.push({...obj,...obj["dummy_data"][0],...total_objNew});
          data2[x.groupByArrayName].push({
            ...obj,
            ...obj["dummy_data"][0],
            ...total_objNew,
          });
          // this.finalllTTransaction.push(obj)
        });

        let findIndexxxNeww = this.selectedGroupByArray.findIndex((jjj) => {
          return jjj.groupByKeyName == x.groupByKeyName;
        });
        //console.log(findIndexxxNeww, "fsfsd", data2[x.groupByArrayName]);
        if (findIndexxxNeww < this.selectedGroupByArray.length - 1) {
          data2[x.groupByArrayName].map((newwwArr) => {
            this.getRecordChildren(
              this.selectedGroupByArray[findIndexxxNeww + 1],
              newwwArr
            );
          });
        }
      },

      showFinalData() {
        this.clearData();
        if (this.selectedCinema.length > 0) {
          let dataArr = this.FilmWise.filmWiseCollectionResult;
          let filteredIndex;
          let temp_arr = [];
          this.finalResArr = [];

          this.selectedCinema.map((z) => {
            dataArr.map((arr1) => {
              arr1.map((arr2) => {
                arr2.Data.map((arr3) => {
                  temp_arr.push(arr3);
                });
              });
            });
            // temp_arr.map(z=>{
          });

          this.selectedGroupByArray.map((x, index) => {
            if (index == 0) {
              let data = _.groupBy(temp_arr, x.groupByKeyName);

              Object.keys(data).map((z) => {
                let obj = {};
                obj[x.groupByKeyName] = z;
                obj["dummy_data"] = [];
                data[z].map((k) => {
                  obj["dummy_data"].push(k);
                });
                let total_objNew = { ...this.totalObj };
                Object.keys(this.totalObj).map((_t) => {
                  obj["dummy_data"].map((d_val) => {
                    if (d_val[_t] && d_val.hasOwnProperty(_t)) {
                      total_objNew[_t] =
                        total_objNew[_t] + parseFloat(d_val[_t]);
                    }
                  });
                });

                this.finalResArr.push({
                  ...obj,
                  ...obj["dummy_data"][0],
                  ...total_objNew,
                });
              });
            } else if (index == 1) {
              this.finalResArr.map((final_val) => {
                this.getRecordChildren(x, final_val);
              });
            }
          });

          console.log(this.finalResArr);
        }
      },
      clearData() {
        this.finalResArr = [];
      },
    },
  };
</script>
<style>
  .swc-report-table th,
  .swc-report-table td {
    padding: 5px 15px 5px 15px;
  }

  /* .align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
} */

  /* .align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */

  /* .filmwise-report-table{
  white-space: normal;
  table-layout: fixed !important;
} */

  .filmwise-report-table > div {
    display: contents;
  }

  .filmwise-report-table td,
  .filmwise-report-table th {
    border-color: #787878;
  }
  .color-blue {
    background: #c1d7eb;
  }
  .color-pink {
    background: #f8e4d8;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/filmWiseCollectionReportv2_new.vue